module.exports = __webpack_public_path__ + "img/icon-gas-water-heater-oven-stove.149c3f2f.svg";